interface ResponsiveImageProps {
  src: string;
  alt: string;
  className?: string;
  onClick?: (event: any) => void; // eslint-disable-line @typescript-eslint/no-explicit-any
}

const ResponsiveImage = ({
  src,
  alt,
  className,
  onClick,
}: ResponsiveImageProps) => (
  <img
    className={className}
    alt={alt}
    src={src + "$rsp-pdp-port-1080$"}
    srcSet={`
      ${src}$rsp-pdp-port-320$ 320w,
      ${src}$rsp-pdp-port-640$ 640w,
      ${src}$rsp-pdp-port-640$ 1080w,
      ${src}$rsp-pdp-port-1080$ 1440w
    `}
    sizes="(max-width: 767px) 100vw, (min-width: 768px) 50vw"
    onClick={onClick}
    role="presentation"
  />
);

export default ResponsiveImage;
